import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { ListBox } from "primereact/listbox";
import { ProgressSpinner } from "primereact/progressspinner";
import JobRunnerToggleButton from "../job-runner-toggle-button/JobRunnerToggleButton";
import { useState } from "react";
import TruncatedTitle from "../../general/TruncatedTitle";
import ScheduleDialog from "./ScheduleDialog";
import cronstrue from "cronstrue";
import { JobInfoDTO } from "../../../serviceapi/jobRunnerApi";

interface JobRunnerListBoxProps {
  listLoad: boolean;
  jobs: JobInfoDTO[];
  selectedJob: JobInfoDTO | null;
  runTaskManually: (job: JobInfoDTO) => void;
  handleToggleJobRunner: (jobRunnerId?: string) => void;
  handleJobSelection: (job: any) => void;
  updateJob: (job: JobInfoDTO) => void;
}

const JobRunnerListBox = ({
  listLoad,
  jobs,
  selectedJob,
  runTaskManually,
  handleToggleJobRunner,
  handleJobSelection,
  updateJob,
}: JobRunnerListBoxProps) => {
  const [scheduleDialogJob, setScheduleDialogJob] =
    useState<JobInfoDTO | null>(null);

  const getQuartzCronDescription = (cronExpression: string) => {
    try {
      const parts = cronExpression.split(" ");

      if (parts.length !== 7) {
        return "Invalid Quartz cron expression";
      }

      const unixLikeCron = parts.slice(0, 6).join(" ");

      return cronstrue.toString(unixLikeCron, {
        use24HourTimeFormat: true,
        verbose: true,
        throwExceptionOnParseError: false,
        dayOfWeekStartIndexZero: false,
      });
    } catch (error) {
      return "Invalid Quartz cron expression";
    }
  };

  const listBoxItemTemplate = (option: any) => (
    <span className="flex flex-row justify-content-between align-items-center">
      <TruncatedTitle title={option.taskTitle} />
      <div className="flex flex-row" style={{ flexShrink: 0 }}>
        <Button
          icon="pi pi-play"
          className="p-button-text p-button-sm scheduler-button"
          tooltip="Run task manually"
          tooltipOptions={{ position: "bottom" }}
          onMouseDown={() =>
            confirmDialog({
              message: `Are you sure you want to run "${option.taskTitle}"?`,
              header: "Run Task",
              acceptLabel: "Run",
              rejectLabel: "Cancel",
              accept: () => runTaskManually(option),
            })
          }
        />
        <Button
          icon="pi pi-clock"
          className="p-button-text p-button-sm scheduler-button"
          tooltip={`${getQuartzCronDescription(option.schedule.cron)}`}
          tooltipOptions={{ position: "bottom" }}
          onMouseDown={() => setScheduleDialogJob(option)}
        />
        <JobRunnerToggleButton
          jobRunner={option}
          onJobRunnerToggled={(jobRunnerId) =>
            handleToggleJobRunner(jobRunnerId)
          }
        />
      </div>
    </span>
  );

  return (
    <>
      <div className="left-side">
        <div className="list-box">
          {listLoad ? (
            <div className="list-box-loading">
              <ProgressSpinner />
            </div>
          ) : (
            <ListBox
              value={selectedJob}
              options={jobs}
              onChange={(e) => handleJobSelection(e.value)}
              filter
              filterPlaceholder="Search"
              filterBy="taskId,taskTitle"
              optionLabel="name"
              itemTemplate={listBoxItemTemplate}
              style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
              }}
              listStyle={{ height: "calc(100% - 36px)" }}
            />
          )}
        </div>
      </div>
      {scheduleDialogJob && (
        <ScheduleDialog
          isVisible={!!scheduleDialogJob}
          setIsVisible={() => setScheduleDialogJob(null)}
          job={scheduleDialogJob}
          updateCurrentJob={(job: JobInfoDTO) => updateJob(job)}
        />
      )}
    </>
  );
};

export default JobRunnerListBox;
